export default "__VITE_ASSET__CLfvonL1__"